import { AfterViewInit, Component, Input } from '@angular/core';
import { MailFormComponentViewModel } from './mail-form.viewmodel';
declare var $: any;

@Component({
  selector: 'mail-form',
  templateUrl: 'mail-form.html'
})

export class MailFormComponent implements AfterViewInit {

  @Input() viewModel: MailFormComponentViewModel;


  ngAfterViewInit(): void {
    var droppedFiles = false;
    var fileName = '';
    var $dropzone = $('.dropzone');

    $dropzone.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
    }).on('drop', (e) => {
        if (this.viewModel) {
          this.viewModel.file = e.originalEvent.dataTransfer.files[0];
        }
        
        $('.dropzone .upload').hide();
        $('.dropzone .dropzone-title').hide();
      });

    $("input:file").change(() => {
      if (this.viewModel) {
        this.viewModel.file = $("input:file")[0].files[0];
      }      
      $('.dropzone .upload').hide();
      $('.dropzone .dropzone-title').hide();
    });
  }


}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/mail-form.ts